import { useQuery } from '@tanstack/react-query';
import { useAdminUserSession } from '../../../models/hooks/adminStateHooks';
import { PricebookItem } from '../../../admin/components/tools/PricingWizard/types';

export const PRICEBOOK_ITEM_QUERY_KEY = 'pricebook/item';

export function usePricebookItemQuery({
	pricebookItemId,
	enabled = true,
}: {
	pricebookItemId: string;
	enabled?: boolean;
}) {
	const userSession = useAdminUserSession();
	return useQuery({
		queryKey: [PRICEBOOK_ITEM_QUERY_KEY, pricebookItemId],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<PricebookItem>(
				`admin/BillingUtilities/GetPricebookItemById?pricebookItemId=${encodeURIComponent(pricebookItemId)}`,
				'GET'
			),
		enabled: enabled && !!pricebookItemId,
		staleTime: 5 * 60 * 1000, // 5 minutes
	});
}
